import { render, staticRenderFns } from "./RateTableItem.vue?vue&type=template&id=0f11173a&"
import script from "./RateTableItem.vue?vue&type=script&lang=ts&"
export * from "./RateTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./RateTableItem.vue?vue&type=style&index=0&id=0f11173a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports